import React, { useState } from "react";
import { Camera, ArrowRight, ChevronLeft, ChevronRight, X, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { INTERESTS } from "../mock";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";
import { Icon } from "./Icons";

export default function Gallery({ onVip, isVip }) {
  const { gallery, loading } = useSite();
  const GALLERY = gallery.slice(0, 6).map((g) => ({ ...g, src: imgUrl(g.url), hidden: g.locked && !isVip }));
  const [idx, setIdx] = useState(null);
  const open = idx !== null && !!GALLERY[idx];
  const nav = (d) => setIdx((i) => {
    let n = i;
    for (let k = 0; k < GALLERY.length; k++) { n = (n + d + GALLERY.length) % GALLERY.length; if (!GALLERY[n].hidden) return n; }
    return i;
  });

  return (
    <section id="gallery" className="bg-[#f9f3f2] scroll-mt-20">
      <div className="max-w-[1024px] mx-auto px-6 lg:px-0 lg:pl-[32px] lg:pr-[31px] pt-[22px] pb-[24px]">
        <div className="flex items-center justify-between">
          <h2 className="text-[23px] font-semibold text-[#1b1719] flex items-center gap-3">
            <Camera className="w-7 h-7" fill="#1b1719" stroke="#f9f3f2" /> Photos, Stories & Exclusive Content
          </h2>
          <button onClick={onVip} className="see-more" data-testid="see-more-vip">
            See more in VIP <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-[12px] mt-[16px]">
          {GALLERY.map((g, i) => (
            <button key={g.id} onClick={() => (g.hidden ? onVip() : setIdx(i))} className="g-tile" data-testid={`gallery-item-${g.id}`}>
              <img src={g.src} alt={g.caption} loading="lazy" className={g.hidden ? "blur-lg scale-110" : ""} />
              {g.hidden && (
                <span className="absolute inset-0 z-[1] grid place-items-center bg-black/25 text-white" data-testid="gallery-locked">
                  <span className="flex flex-col items-center gap-1 text-[12px] font-medium"><Lock className="w-6 h-6" />VIP only</span>
                </span>
              )}
              {!g.hidden && <span className="g-cap">{g.caption}</span>}
            </button>
          ))}
          {loading && Array.from({ length: 6 }).map((_, i) => <div key={i} className="g-tile bg-[#efe6e8] animate-pulse" />)}
        </div>
        <div className="flex flex-wrap justify-between gap-y-4 mt-[30px] px-[28px]">
          {INTERESTS.map((it) => (
            <div key={it.label} className="interest flex items-center gap-[10px]" data-testid="interest-item">
              <Icon name={it.icon} filled={["pin", "heart", "paw", "plane"].includes(it.icon)}
                className="w-[24px] h-[24px] text-[#1b1719]" strokeWidth={2.2} />
            </div>
          ))}
        </div>
      </div>

      <Dialog open={open} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-[520px] p-0 overflow-hidden bg-black border-0 [&>button]:hidden">
          <DialogTitle className="sr-only">Gallery</DialogTitle>
          {open && (
            <div className="relative">
              <img src={GALLERY[idx].src} alt="" className="w-full max-h-[78vh] object-cover" />
              <button className="lb-btn left-3" onClick={() => nav(-1)} data-testid="lightbox-prev"><ChevronLeft /></button>
              <button className="lb-btn right-3" onClick={() => nav(1)} data-testid="lightbox-next"><ChevronRight /></button>
              <button className="lb-btn top-3 right-3 !translate-y-0" onClick={() => setIdx(null)} data-testid="lightbox-close"><X /></button>
              <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-white flex items-end justify-between">
                <span className="text-[15px]">{GALLERY[idx].caption}</span>
                <button onClick={() => { setIdx(null); onVip(); }} className="text-[13px] text-[#ff7aa6] hover:text-white">Unlock more in VIP →</button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
